export const earn = {
  jdzb: "簡單賺幣",
  jryd: "金融有道，攜手共進",
  jrbk: "加入 Biking簡單賺幣，創新無限讓您的數位資產獲得最大收益",
  zbz: "賺幣中",
  ljsy: "累計收益",
  zrsy: "昨日收益",
  hq: "活期",
  cknh: "參考年化",
  sqjd: "申購進度",
  sg: "申購",
  qbcp: "全部產品",
  cz: "重置",
  qx: "期限",
  question1: "1. 什麼是賺幣 ？",
  question1_text: "賺幣是BIKING打造的幫助用戶發現多種持幣產品機會的一站式服務平台。目前推出簡單賺幣即餘幣寶（隨存隨取），後續將上線更多產品，為用戶 提供豐富的產品選擇。",
  question2: "2. 什麼是參考年化？",
  question2_text: "賺幣收益目前為存入代幣的利息。 參考年化是存入代幣的利息年化，例如一產品首1000U以12%參考年化，超過首1000U以2%參考年化，總參考利息年化為14%。",
  question3: "3. 什麼時間開始起息/結息？",
  question3_text: "申購不同的產品時，開始起息/結息的時間可能不同。以目前USDT的日計息的簡單賺幣為例，購買USDT活期產品的次日凌晨2點起息（UTC+8）, 起息 時間T+1（即購買時間T+2）的凌晨5點（UTC+8）發放隔日結算前一日的利息；",
  question4: "4. 什麼是剩餘可投？",
  question4_text: "剩餘可投是您還能申購該理財產品的數量<br/>剩餘可投=總產品可購額度-您已申購的數量",
  xzmbfs: "選擇充幣/買幣方式",
  nhsyl: "年化報酬率及期限：",
  sl: "數量",
  qitou: "起投",
  max: "最大",
  kzcsl: "此為资金帳戶可轉出數量",
  sykt: "剩餘可投",
  syktsl: "剩餘可投是您還能申購的數量",
  syktsx: "剩餘可投=總產品可購額度-您已申購的數量（不大於個人可投上限{amount}{coin}）",
  jlgz: "獎勵規則",
  jd1: "階梯1:首{amount}{coin}",
  ptjl: "平台獎勵",
  jd2: "階梯2:大於首{amount}{coin}",
  jd22:"階梯",
  jd3: "階梯2:大於{amount}{coin}",
  grsgsx: "個人申購上限為{amount}{coin}",
  gz: "規則",
  sgsj: "申購時間",
  xianzai: "現在",
  qxsj: "起息時間",
  lxrz: "利息入帳",
  c2c: "C2C買幣",
  lhxz: "彈性選擇，價格更優",
  lcjd: "流程簡單，快速成交",
  crszhb: "從錢包或交易所存入數位貨幣",
  zcsl: "資產數量",
  dzsy: "到帳收益",
  lcxx: "理財資訊",
  zt: "狀態",
  sh: "贖回",
  sgje: "申購金額",
  sgzj: "申購資金的首{amount}{coin}可賺取{value}%獎勵年化",
  dyklqje: "大於{amount}{coin}的可賺取{value}%獎賞年化",
  grsged: "個人申購額度為{amount}～{amoun2}{coin}",
  shsl: "贖回數量",
  srshsl: "輸入贖回數量",
  ksh: "可贖回：",
  haode: "好的",
  zcsg: "再次申購",
  sjdzsl: "實際到帳數量",
  shsj: "贖回時間",
  jssj: "結算時間",
  sgcg: "申購成功",
  shcg: "贖回成功",
  dq: "定期",
  yjsdd: "已結算訂單",
  jyjl: "交易記錄",
  hqjdzb: "活期簡單賺幣",
  sy: "收益",
  wwc: "未完成",
  xmlx: "專案類型",
  hqjdzbcp: "活期簡單賺幣,是Biking打造的安全理財產品,支援24小時隨存隨取,按小時計息",
  nh: "年化",
  zhzchz: "帳戶資產互轉，簡潔快速",
  qsrsl: "請輸入數量",
  yjssymx: "已結算收益明細",
  mx: "明細",
  qwsmrz: "前往實名認證",
  jxwcsmrz: "1.本次活動僅限完成實名認證的用戶，每位用戶僅有一次參與該活動機會",
  dqcked: "2.每位使用者定期存款額度為{min}~{max}{coin}，到期系統自動贖回至帳戶",
  cpbntjsh: "3.該產品不能提前贖回",
  anzh: "4.產品認購完，總池為0，按鍵置灰",
  smrzyh: "活動僅限完成實名認證的使用者,",
  jxcjyc: "每位符合資格的使用者僅限參與一次",
  ygsy: "預估收益",
  scqx: "鎖倉期限",
  qixian: "第{min}天 (共{max}天)",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/earn/tw.js